import { Nullable } from 'clickNgo/models/utils'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

interface IGetValue {
  valueType?: ActualsValueTypes
  defaultValue: Nullable<number>
  ndpValue?: Nullable<number>
  netValue?: Nullable<number>
  tnetValue?: Nullable<number>
  utnetValue?: Nullable<number>
}
export const getValueTypeValue = ({
  defaultValue,
  ndpValue,
  netValue,
  tnetValue,
  utnetValue,
  valueType,
}: IGetValue) => {
  switch (valueType) {
    case ActualsValueTypes.Net:
      return netValue ?? 0
    case ActualsValueTypes.Ndp:
      return ndpValue ?? 0
    case ActualsValueTypes.TNet:
      return tnetValue ?? 0
    case ActualsValueTypes.UTNet:
      return utnetValue ?? 0
    default:
      return defaultValue ?? 0
  }
}
